module.exports = __webpack_public_path__ + "images/jobs/hat.3bd61397.svg";